import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Home.scss';
import Navbar from './Navbar';
import Services from './Services';
import AboutUs from './Aboutus';
import SalonLocation from './SalonLocation';
import Contact from './Contact';
import Gallery from './Gallery';
import Footer from './Footer';

const useScrollToHash = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    const element = document.getElementById(id);
    if (!element) return;
    requestAnimationFrame(() => {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [hash]);
};

const Home = () => {
  const [scrolled, setScrolled] = useState(0);

  useScrollToHash();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const overlayOpacity = 0.38 + Math.min(scrolled, 120) / 350;

  return (
    <div className="home-root">
      {/* ── Hero ── */}
      <div className="home-hero">
        <div
          className="overlay"
          style={{ background: `rgba(20, 8, 18, ${overlayOpacity})` }}
        />
        <div className="hero-content">
          <div className="hero-badge">Est. 2015 &nbsp;·&nbsp; Perambur, Chennai</div>

          <h1 className="hero-name">
            <span className="hero-name__priyaa">Priyaa's</span>
            <span className="hero-name__salon">Beauty Salon</span>
          </h1>

          <p className="hero-tagline">Where Beauty Meets Luxury</p>

          <a href="#services" className="cta-btn">
            <span>Explore Our Services</span>
            <svg className="cta-btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M5 12l7 7 7-7" />
            </svg>
          </a>
        </div>

        <div className="hero-scroll-hint">
          <span />
        </div>
      </div>

      <Navbar />

      <section id="services"><Services /></section>
      <section id="about"><AboutUs /></section>
      <section id="gallery"><Gallery /></section>
      <section id="location"><SalonLocation /></section>
      <section id="contact"><Contact /></section>
      <Footer />
    </div>
  );
};

export default Home;
